import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { createContext, useContext, useMemo, useState } from 'react';
const SearchScreenContext = createContext(null);
export function SearchScreenProvider({ children }) {
    const [isFromLookup, setIsFromLookup] = useState(false);
    const value = useMemo(() => ({
        isFromLookup,
        setIsFromLookup,
    }), [isFromLookup]);
    return (_jsx(SearchScreenContext.Provider, { value: value, children: children }));
}
export function useSearchScreenContext() {
    const context = useContext(SearchScreenContext);
    if (!context) {
        throw new Error('useSearchScreenContext must be used within SearchScreenProvider');
    }
    return context;
}
